import { useState, useEffect } from 'react'

export default prop => {
  const [prevProp, setPrevProp] = useState(null)
  useEffect(() => () => setPrevProp(prop), [prop])
  return prevProp
}
